module.exports = __webpack_public_path__ + "fonts/iconfont.9d6a3d21.ttf";